<template>
  <div v-show="error">
    <p class="error">{{ text ? text : error }}</p>
  </div>
</template>

<script>
export default {
  name: 'ValidationError',
  props: {
    id: String,
    error: String,
    text: String,
  }
}
</script>

<style lang="scss" scoped>
.error {
  margin-top: 8px;
  font-size: 12px;
  color: #E9446A;
  white-space: pre-line;
}
</style>
